import { render, staticRenderFns } from "./RoadTax.vue?vue&type=template&id=5ff70d74&scoped=true"
import script from "./RoadTax.vue?vue&type=script&lang=js"
export * from "./RoadTax.vue?vue&type=script&lang=js"
import style0 from "./RoadTax.vue?vue&type=style&index=0&id=5ff70d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff70d74",
  null
  
)

export default component.exports